import React, { Component, PropTypes } from 'react';
import { Menu, Modal, Form } from 'antd';

import { browserHistory } from 'react-router';

import { connect } from 'react-redux';
import { getUserById, editUser, verifyUser, rejectUser, getPointList, getSpentPointList } from 'data/user';

import classes from '../styles/student/StudentInfo.module.scss';
import AddPointModal from 'components/Modal/AddPoint';
import StudentHeader from './StudentHeader';
import StudentInfoTab from './StudentInfoTab';
import StudentOrder from './StudentOrder';
import StudentPoint from './StudentPoint';
import StudentOrderItem from './StudentOrderItem';

const Confirm = Modal.confirm;

class StudentInfo extends Component {
  constructor(props) {
    super(props);
    this.onToggleMode = this.onToggleMode.bind(this);
    // this.onTeacherInputChange = _.debounce(this.onTeacherInputChange, 300);
    // this.onTeacherInputChange = this.onTeacherInputChange.bind(this);

    // this.onSelectTeacher = this.onSelectTeacher.bind(this);
    this.handleVerify = this.handleVerify.bind(this);
    this.handleReject = this.handleReject.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.showImageModal = this.showImageModal.bind(this);
    this.onChangeFocusTab = this.onChangeFocusTab.bind(this);
    if (browserHistory) {
      this.backListener = browserHistory.listen((location) => {
        if (location.action === 'POP') {
          this.setState({ selectedTab: location.query.selectedTab ? location.query.selectedTab : 'info' });
        }
      });
    }
    this.state = {
      collapseMobile: [],
      mode: 'editor',
      showModal: false,
      selectedTab: props.location.query.selectedTab ? props.location.query.selectedTab : 'info',
    };
  }

  componentDidMount = async () => {
    const promises = [];

    const id = this.props.params.id;
    this.setState({
      loading: true,
    });
    const user = await getUserById(id);

    const points = await getPointList(id);
    const spentPoints = await getSpentPointList(id);
    this.setState({
      loading: false,
      user,
      spentPoints,
      points,
    });

    // promises.push(dispatch(getUserOrders(id)));
    // promises.push(dispatch(getPointList(id)));
    // promises.push(dispatch(getSpentPointList(id)));

    return Promise.all(promises);
  };

  componentWillMount() {
    this.setState({
      showModal: false,
    });
  }
  componentWillUnmount() {
    this.backListener();
  }

  onToggleMode() {
    const mode = this.state.mode === 'editor' ? 'preview' : 'editor';
    this.setState({
      mode,
    });
  }

  onChangeFocusTab(tab) {
    this.setState({ selectedTab: tab.key });
    browserHistory.push(`${this.props.location.pathname}?selectedTab=${tab.key}`);
  }

  onOpenAddPointModal() {
    this.setState({
      isOpenAddPointModal: true,
    });
  }

  reloadData = async () => {
    this.setState({
      loading: true,
    });
    const user = await getUserById(this.state.user._id);

    const points = await getPointList(this.state.user._id);
    const spentPoints = await getSpentPointList(this.state.user._id);
    this.setState({
      loading: false,
      user,
      spentPoints,
      points,
    });
    // this.props.getTeacherById(this.props.teacher._id);
  };
  closeAddPointModal() {
    this.setState({
      isOpenAddPointModal: false,
    });
  }

  showImageModal(url) {
    this.setState({
      showModal: true,
      imageUrl: url,
    });
  }
  showBanConfirm = (record, msg, content) => {
    Confirm({
      title: 'Do you want to confirm?',
      // content: content || '',
      onOk: () => {
        const user = this.props.user;
        editUser(user._id, { isBan: !user.isBan }).then(() => {
          this.props.getUserById(user._id);
        });
      },
      // onCancel: this.onCancel,
    });
  };

  handleVerify(id) {
    this.props.verifyUser(id).then(() => {
      browserHistory.push('/student');
    });
  }

  handleReject(id) {
    this.props.rejectUser(id).then(() => {
      browserHistory.push('/student');
    });
  }

  handleCancel() {
    this.setState({
      showModal: false,
      imageUrl: '',
    });
  }

  renderModal() {
    const imageUrl = this.state.imageUrl;

    if (!this.state.showModal) {
      return <div />;
    }
    return (
      <Modal width="960px" className={classes.imageModal} title="" visible={this.state.showModal} onCancel={this.handleCancel} footer={null}>
        <img src={imageUrl} />
      </Modal>
    );
  }
  renderTabs() {
    return (
      <Menu onClick={this.onChangeFocusTab} selectedKeys={[this.state.selectedTab]} mode="horizontal">
        <Menu.Item key="info" className={classes.menuItem}>
          <div>Student Info</div>
        </Menu.Item>
        <Menu.Item key="orders" className={classes.menuItem}>
          <div>Orders</div>
        </Menu.Item>

        <Menu.Item key="points" className={classes.menuItem}>
          <div>T-Points</div>
        </Menu.Item>
      </Menu>
    );
    //purchasedClass
  }

  render() {
    // console.log(this.state.files);
    const { loading, user } = this.state;
    console.log(this.state.selectedTab);

    return (
      <div>
        <div className="page-header">
          {this.props.BreadCrumb}
          <StudentHeader user={this.state.user} Tabs={this.renderTabs()} onOpenBanModal={() => this.showBanConfirm()} onOpenAddPointModal={() => this.onOpenAddPointModal()} />
        </div>
        {this.state.selectedTab === 'info' && <StudentInfoTab user={this.state.user} loading={this.state.loading} reloadData={this.reloadData} />}
        {this.state.selectedTab === 'orders' && <StudentOrder user={this.state.user} />}

        {this.state.selectedTab === 'points' && (
          <StudentPoint ser={this.state.user} loading={this.state.loading} points={this.state.points} spentPoints={this.state.spentPoints} reloadData={this.reloadData} />
        )}
        {this.state.isOpenAddPointModal && <AddPointModal reload={() => this.reloadData()} handleCancel={() => this.closeAddPointModal()} student={user} />}
      </div>
    );
  }
}

export default connect(
  (state) => ({
    // pages: state.content.pages,
    // user: state.user.userDetail,
    // loading: state.user.userDetailWaiting,
    // orders: state.order.userOrderList,
  }),
  { verifyUser },
)(Form.create()(StudentInfo));
